import { orderBy } from "es-toolkit/compat"
import type { FragmentOf } from "gql.tada"
import { readFragment } from "gql.tada"
import { readItemHighestTraitFloorFragment } from "./readItemHighestTraitFloor.fragment"

type Price = {
  token: {
    unit: number
    symbol: string
  }
}

export function readItemHighestTraitFloor(
  itemKey: FragmentOf<typeof readItemHighestTraitFloorFragment>,
): Price | undefined {
  const item = readFragment(readItemHighestTraitFloorFragment, itemKey)

  const attributesSortedByFloorPrice = orderBy(
    item.attributes,
    "floorPrice.token.unit",
    "desc",
  )

  const highestTraitFloor = attributesSortedByFloorPrice[0]?.floorPrice

  return highestTraitFloor ?? undefined
}
